import React from "react";

import { OverflowTooltip } from "components";
import { FeeTemplateQueue } from "globalConstants";
import { FeeTemplateQueueType, TableCellProp } from "types";

import { ReactComponent as TemplateIcon } from "static/images/templateIcon.svg";
import styles from "../feeTemplatesQueue.module.scss";

const { Name } = FeeTemplateQueue;

const NameColumn = () => ({
	accessor: Name.name,
	disableSortBy: true,
	classNameCell: styles.feeTemplateCell,
	Cell: ({ value, row }: TableCellProp<FeeTemplateQueueType>) => {
		const userFriendlyIndex = row?.index + 1;

		return (
			<OverflowTooltip onlyOnLaptop title={value}>
				<div className="d-flex align-items-center ">
					<div className="ml-2">{userFriendlyIndex}</div>
					<div className="mx-4">
						<TemplateIcon />
					</div>
					<div>{value}</div>
				</div>
			</OverflowTooltip>
		);
	},
});

export default NameColumn;
